<template>
  <v-tooltip v-bind="tooltipAttrs" :disabled="!tooltip">
    <template #activator="{ attrs, on }">
      <div v-bind="attrs" v-on="on">
        <span :class="{ 'is-borderless': borderless }" class="label__link w-inline-block LKIconLink">
          <img src="/images/i-link.svg" alt="" class="label__link-img">
        </span>
      </div>
    </template>
    <div
      style="max-width: 150px;"
      v-text="tooltip"
    />
  </v-tooltip>
</template>

<script>
export default {
  name: 'LKIconLink',
  props: {
    count: Number,
    borderless: Boolean,
    tooltip: String,
    tooltipAttrs: {
      type: Object,
      default: () => ({ top: true }),
    },
  },
}
</script>

<style lang="scss">
.LKIconLink {
  &.is-borderless {
    border-color: transparent;
  }
}
</style>
